import * as React from 'react';
import * as style from './style.scss';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { Text, Heading, ToggleSwitch } from 'wix-style-react';
import { EXPERT_SECTION, EXPERT_TOGGLE_SWITCH } from '../../../../consts/data-hooks';
import { InjectedBiLoggerProps, provideLogger } from '../../../../services/bi-logger/logger-provider';

export interface ExpertExpProps {
  setGloballyMuted: (isGloballyMuted: boolean) => void;
  isGloballyMuted: boolean;
}

class ExpertExperience extends React.Component<InjectedTranslateProps & ExpertExpProps & InjectedBiLoggerProps> {

  image = require('../../../../assets/images/expert.png');

  changeNotifications = () => {
    const { isGloballyMuted, setGloballyMuted, logger } = this.props;
    logger.reportMuteAllSite(!isGloballyMuted);
    setGloballyMuted(!isGloballyMuted);
  }

  render() {
    const { t, isGloballyMuted } = this.props;
    return (
      <section className={style['settings-section']} data-hook={EXPERT_SECTION}>
        <img className={style['section-icon']} src={this.image}/>
        <div className={style.content}>
          <Heading appearance="H3">{t('experts.title')}</Heading>
          <div className={style['content-body']}>
            <div className={style['content-body-description']}>
              <Text size="medium" weight="thin" secondary>{t('experts.description')}</Text>
            </div>
            <ToggleSwitch
              dataHook={EXPERT_TOGGLE_SWITCH}
              checked={!isGloballyMuted}
              onChange={this.changeNotifications}/>
          </div>
        </div>
      </section>
    );
  }
}

export const ExpertSection = provideLogger<ExpertExpProps>(translate()(ExpertExperience));
